import { render, staticRenderFns } from "./BindBankCard.vue?vue&type=template&id=d78f8456&scoped=true&"
import script from "./BindBankCard.vue?vue&type=script&lang=js&"
export * from "./BindBankCard.vue?vue&type=script&lang=js&"
import style0 from "./BindBankCard.vue?vue&type=style&index=0&id=d78f8456&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d78f8456",
  null
  
)

export default component.exports